import {Injectable} from "@angular/core";
import {BaseRepository} from "../base-repository";
import { Observable } from "rxjs";
import { EntityLogInfo } from "../logs/entity-log-info";
import {Apollo} from 'apollo-angular';
import {
  ClientCredential,
  Company,
  GET_COMPANY,
  GET_COMPANIES,
  UPDATE_COMPANY,
  CREATE_OR_UPDATE_CLIENT_CREDENTIAL,
  DELETE_COMPANY
} from './company.barrel';
import { map } from 'rxjs/operators';
import {DefinedPaths} from "../../constants/defined-paths";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class CompanyRepository extends BaseRepository<Company> {
  constructor(apollo: Apollo,private http: HttpClient,private paths: DefinedPaths) {
    super(apollo, GET_COMPANIES);
  }
  override get(id: string): Observable<Company> {
    return this.apollo.watchQuery<{ company: Company }>({
      query: GET_COMPANY,
      variables: { id },
    }).valueChanges.pipe(map(result => result.data.company));
  }

  override getAll(): Observable<Company[]> {
    return this.apollo.watchQuery<{ companies: Company[] }>({
      query: GET_COMPANIES,
    }).valueChanges.pipe(map(result => result.data.companies));
  }
  getFromRestApi(): Observable<Company[]> {
    return this.http.get<Company[]>( this.paths.UserCompanyEndpoint);
  }

  override create(company: Partial<Company>, logInfo: EntityLogInfo): Observable<Partial<Company>> {
    return this.http.post<Company>(this.paths.CompanyEndpoint, {company, logInfo});
  }

  override update(data: Partial<Company>, logInfo: EntityLogInfo): Observable<Partial<Company>> {
    return this.apollo.mutate<{ updateCompany: Company }>({
      mutation: UPDATE_COMPANY,
      variables: { company: data, logInfo },
    }).pipe(map(result => {
      if (result.data?.updateCompany)
        return result.data.updateCompany;
      throw new Error('Failed to Update Merchant');
    }));
  }
  createOrUpdateClientCredential(data: Partial<ClientCredential>, logInfo: EntityLogInfo): Observable<Partial<ClientCredential>> {
    return  this.apollo.mutate<{ addClientCredential: ClientCredential }>({
      mutation: CREATE_OR_UPDATE_CLIENT_CREDENTIAL,
      variables: { clientCredential: data, logInfo },
    }).pipe(map(result => {
      if (result.data?.addClientCredential)
        return result.data.addClientCredential;
      throw new Error('Failed to Create or Update Client Credential');
    }));
  }
  override delete(id: string, logInfo: EntityLogInfo): Observable<boolean> {
   return this.apollo.mutate<{ deleteCompany: boolean }>({
      mutation: DELETE_COMPANY,
      variables: { id, logInfo },
    }).pipe(map(result => {
      if (result.data?.deleteCompany)
        return result.data.deleteCompany;
      throw new Error('Failed to Delete Company');
    }));

  }
}
